<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-首页列表
  -->
  <div class="user">
    <!--添加页面-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick()" v-auth="'/page/home/add'">添加首页模板</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="global_style_id" label="首页ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.page_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="首页名称">
            <template slot-scope="scope">
              <span>{{ scope.row.page_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column prop="update_time" label="更新时间"></el-table-column>
          <el-table-column prop="is_default" label="设为默认">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_default" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="170">
            <template slot-scope="scope">
              
                <el-button @click="editClick(scope.row.page_id)" type="text" size="small" v-auth="'/page/home/edit'">编辑</el-button>
                <el-button v-if="!scope.row.is_default" @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/page/page/delete'">删除</el-button>
              <el-button @click="copyPage(scope.row.page_id)" type="text" size="small" v-auth="'/page/home/copy'">一键复制</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
import PageApi from '@/api/page.js';
import { colorReverse as colorR } from '@/utils/base.js'
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 0,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();

  },
  methods: {
      /*复制*/
    copyPage(page_id) {
      let self = this;
      self.loading = true;
      PageApi.editIndexPage({page_id:page_id}, true)
        .then(res => {

          self.diyData = res.data.jsonData;
          let scene = "copy";


              PageApi.SavePage(
              {
                page_id: page_id,
                scene:scene,
                Parmens: self.diyData,
              },
              true
            )
              .then(data => {
                self.loading = false;

        
                self.curPage = 1;
                self.getTableList();
           
            
                self.$message({
                  message: '恭喜你，复制成功',
                  type: 'success'
                });
         
              })
              .catch(error => {
                self.loading = false;
              });
 
        })
        .catch(error => {
          self.loading = false;
        });

    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.page_type = 10;
      PageApi.getIndexList(Params, true).then(data => {
        self.loading = false;
        self.tableData = data.data.list.data;
        self.totalDataNumber = data.data.list.total;
      }).catch(error => {

      });
    },

    /*删除数据*/
    deleteClick(row) {
      let self = this;
      console.log(row)
      if (row.is_default) {
        self.$message({
          message: '默认风格不能删除',
          type: 'error'
        })
        return false
      }

      self.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        PageApi.setPageDefault({
          type:2,
          page_id: row.page_id
        }, true).then(data => {
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，删除成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        })
      }).catch(() => {}).finally(res => {
        self.loading = false;
      })
    },

    /*添加页面*/
    addClick() {
      this.$router.push('/page/home/add');
    },

    /*编辑*/
    editClick(page_id) {
      let self = this;
      self.$router.push({
        path: '/page/home/edit',
        query: {
          id: page_id
        }
      })

    },
    /* 设置默认 */
    isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row.is_default);
        let is_defalut = 1;
        if(row.is_default){
          is_defalut = 1;
        }else{
          is_defalut = 0;
        }
        self.loading = true;
        PageApi.setPageDefault({page_id: row.page_id,type:1,is_default:is_defalut,page_type:10}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })
    },

    /**
     * 颜色取反色
     * @param oldColor
     * @returns {string}
     */
    colorReverse(oldColor) {
      return colorR(oldColor)
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/page/home/index.vue